import a from './a';
import audio from './audio';
import blockquote from './blockquote';
import button from './button';
import form from './form';
import iframe from './iframe';
import img from './img';
import input from './input';
import label from './label';
import li from './li';
import ol from './ol';
import optgroup from './optgroup';
import option from './option';
import select from './select';
import svg from './svg';
import textarea from './textarea';
import time from './time';
import video from './video';

const sanitizers: Record<
  string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (props: Record<string, any>) => Record<string, any>
> = {
  a,
  audio,
  blockquote,
  button,
  form,
  iframe,
  img,
  input,
  label,
  li,
  ol,
  optgroup,
  option,
  select,
  svg,
  textarea,
  time,
  video,
};

export default sanitizers;
